var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollbackDice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 7.39062C15.125 7.39062 13 7.23438 12 7.23438C10.7639 7.23438 9.5555 7.60093 8.52769 8.28769C7.49988 8.97445 6.6988 9.95056 6.22576 11.0926C5.75271 12.2346 5.62894 13.4913 5.87009 14.7037C6.11125 15.9161 6.70651 17.0297 7.58059 17.9038C8.45466 18.7779 9.56831 19.3731 10.7807 19.6143C11.9931 19.8554 13.2497 19.7317 14.3918 19.2586C15.5338 18.7856 16.5099 17.9845 17.1967 16.9567C17.8834 15.9289 18.25 14.7205 18.25 13.4844M15.125 7.39062L12 4.26562M15.125 7.39062L12 10.5156",
    stroke: "#EFEFEF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollbackDice);
export default __webpack_public_path__ + "static/media/rollback-dice.75996856b5c4a55405e70ff95ae503be.svg";
export { ForwardRef as ReactComponent };